import { customerStatusLabels } from "./mgmtDataConfig";

/**
 * VIEW_COLUMNS defines the read-only columns for customer table view mode.
 */
export const VIEW_COLUMNS = [
  {
    key: "customerName",
    label: "Name",
    render: (customer) => customer.customerName || "",
  },
  {
    key: "city",
    label: "City",
    render: (customer) => customer.city || "",
  },
  {
    key: "statusID",
    label: "Status",
    render: (customer) =>
      customerStatusLabels[customer.statusID] || customer.statusID || "",
  },
  {
    key: "billingClass",
    label: "Billing Class",
    render: (customer) => customer.billingClass || "",
  },
  {
    key: "activeBalance",
    label: "Balance",
    render: (customer) => `$${customer.activeBalance || "0.00"}`,
  },
];

/**
 * EDIT_COLUMNS defines the editable columns for customer table in edit mode.
 * Each column can specify a type and, for select fields, a list of options.
 */
export const EDIT_COLUMNS = [
  {
    key: "customerName",
    label: "Name",
    type: "text",
  },
  {
    key: "city",
    label: "City",
    type: "text",
  },
  {
    key: "statusID",
    label: "Status",
    type: "select",
    options: Object.entries(customerStatusLabels), // Array of [key, label]
  },
  {
    key: "billingClass",
    label: "Billing Class",
    type: "select",
    options: [["", "Select Billing Class"]],
  },
  { key: "activeBalance", label: "Balance", type: "text" },
];
